





































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import pagelist from "@/components/pagelistcomponent";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import VueAnimateNumber from "vue-animate-number";
@Component({
  components: { VueAnimateNumber },
})
export default class home extends pagelist {
  model: any = {};
  list = [];
  tmodel: any = new proxy.QueryHomeTotalOutDto();
  userinfo = new proxy.UserInfoDto();
  products = [];
  htotal = new proxy.HomeOutDto();
  merchants = [];
  created() {
    this.tmodel = new proxy.QueryHomeTotalOutDto();
    this.tmodel.yestodaySuccessOrderAmount = 0;
    this.tmodel.yestodaySuccessOrderNum = 0;
    this.tmodel.yestodaySuccessRate = 0;
    this.tmodel.yestodayTotalOrderAmount = 0;
    this.tmodel.yestodayTotalOrderNum = 0;
    this.tmodel.liRun = 0;
    this.tmodel.dlLiRun = 0;

    this.tmodel.successOrderAmount = 0;
    this.tmodel.successOrderNum = 0;
    this.tmodel.successRate = 0;
    this.tmodel.totalOrderAmount = 0;
    this.tmodel.totalOrderNum = 0;
    this.tmodel.yestodayLiRun = 0;
    this.tmodel.yestodayDlLiRun = 0;
    this.model.createTime = new Date(
      new Date(new Date().toLocaleDateString()).getTime()
    );
    this.model.endTime = new Date(
      new Date(new Date().toLocaleDateString()).getTime() + 86400000 - 1
    );
    new proxy.ChannelSuccessRateServiceProxy()
      .queryModelList(this.model)
      .then((x) => {
        this.list = x;
      });

    new proxy.FinanceManageServiceProxy().zhuYeQueryChannelTypeStatistics().then(x => {
      this.products = x;
    })
    new proxy.FinanceManageServiceProxy().zhuYeQueryMerchantStatistics().then(x => {
      this.merchants = x;
    })
    new proxy.PayOrderServiceProxy().queryHomeTotal().then((x) => {
      this.tmodel = x;
      this.$forceUpdate();
    });
    new proxy.UserManageServiceProxy().queryMyUser().then((x) => {
      this.userinfo = x;
    });
    new proxy.HomeServiceProxy().queryTotal().then(x => {
      this.htotal = x;
    })
  }
  formatter(num) {
    num = Number(num);
    return "￥" + num.toFixed(2) + "元";
  }
  goto(path, query) {
    this.$router.push({
      path: path,
      //这里传的是一个对象
      query: query,
    });
  }
}
